import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import BlogArticle from "../pages/blog/article";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/blog/:slug",
    element: <BlogArticle />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;